import React from 'react'

function ChatLeftUser(props) {
    return (

        <div className="chatleftrow">
            <div style={{minWidth: "7rem"}} className="userchat">
                <h4 className='small1'>{props.sender && "~ " + props.sender}</h4>
                <p>{props.body}</p>
                <small className='small2'>{props.time}</small>
            </div>
        </div>

    )
}

export default ChatLeftUser